"use strict";

exports.__esModule = true;
exports.default = void 0;

var _polished = require("polished");

var _pallette = _interopRequireDefault(require("./pallette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled-components theme for Reassure-UI layout components
 */
const {
  transparent,
  white,
  black,
  lightBlue,
  darkBlue,
  teal
} = _pallette.default;
var _default = {
  colors: {
    cookieConsent: {
      text: white,
      background: (0, _polished.darken)(0.09, darkBlue),
      border: (0, _polished.darken)(0.09, darkBlue)
    },
    footer: {
      text: white,
      background: darkBlue,
      border: lightBlue
    },
    scrollArea: {
      scrollbar: (0, _polished.rgba)(teal, 0.3),
      hover: {
        scrollbar: teal
      }
    },
    table: {
      border: darkBlue,
      header: {
        text: teal,
        background: darkBlue
      },
      body: {
        text: white,
        background: transparent,
        stripedRow: (0, _polished.rgba)(black, 0.09)
      },
      footer: {
        text: teal,
        background: darkBlue
      }
    },
    labelDivider: {
      border: darkBlue,
      badge: {
        text: darkBlue,
        background: teal,
        border: teal
      }
    }
  }
};
exports.default = _default;